module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-1-invalid.90b4f4aa.png";